/**
 * @function
 * @description Convert a string to have the first letter in upper case and last letters in lower case.
 *
 * @param {string} str - The string to be modified.
 * @return {string} - The modified string with the first letter in upper case and last letters in lower case.
 *
 * @throws {TypeError} - If the input is not a string.
 */
export const convertStringCase = (str: string | any): string => {
  if (typeof str !== 'string') {
    throw new TypeError('Input must be a string');
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
